/**
 * Consulta do log de requisicoes.
 *
 * A tela existe para duas perguntas concretas, e os filtros sao desenhados
 * para elas: "o que deu errado?" e "o que esta lento?". Navegar o log inteiro
 * em ordem cronologica nao e caso de uso de ninguem -- sao centenas de
 * milhares de linhas.
 */
export const nav = {
    section: 'Resources',
    title: 'Logs',
    icon: 'receipt_long',
    route: '/logs',
    accordion: false,
    permissao: 'accounts.logs:ver',
};

export default [
    {
        path: '/logs',
        name: '/logs',
        component: () => import('./pages/LogsListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.logs:ver' },
    },
];
